import { formatDistanceToNowStrict, formatRelative, parseISO } from "date-fns";

/** "12s", "3m", "2h", "1d" — extreme tightness for ops tables. */
export function relTime(iso: string | null | undefined, fallback = "—"): string {
  if (!iso) return fallback;
  const d = typeof iso === "string" ? parseISO(iso) : (iso as Date);
  const seconds = Math.max(0, Math.floor((Date.now() - d.getTime()) / 1000));
  if (seconds < 60) return `${seconds}s`;
  const m = Math.floor(seconds / 60);
  if (m < 60) return `${m}m`;
  const h = Math.floor(m / 60);
  if (h < 48) return `${h}h`;
  const days = Math.floor(h / 24);
  if (days < 14) return `${days}d`;
  return `${Math.floor(days / 7)}w`;
}

/** "12 seconds ago" — used for tooltips. */
export function relTimeLong(iso: string | null | undefined, fallback = "never"): string {
  if (!iso) return fallback;
  const d = typeof iso === "string" ? parseISO(iso) : (iso as Date);
  return formatDistanceToNowStrict(d, { addSuffix: true });
}

/** "Wed at 4:12 PM" — used in pager log. */
export function relTimeReadable(iso: string | null | undefined): string {
  if (!iso) return "—";
  return formatRelative(parseISO(iso), new Date());
}

export function clockHM(d: Date = new Date()): string {
  return d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
}
